import React from "react";
import "./activities.css";
import Button from "@material-ui/core/Button";
import Arrow from "@material-ui/icons/ArrowForwardIos";
import dots from "./images/dots.png";
import { Link } from "react-router-dom";

function Activities() {
  return (
    <div className="bg main">
      <img className="dot1" src={dots} alt="" />
      <img className="dot2" src={dots} alt="" />
      <h1>Youth’s recreation activities and entertainment.</h1>
      <p>
        Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
        sint. Velit officia consequat duis enim velit mollit. Exercitation
        veniam consequat sunt nostrud amet.
      </p>
      <Button className="btn" variant="contained" href="/activities">
        <Link to={"/activities"}>View all activities</Link>
        <Arrow />
      </Button>
    </div>
  );
}

export default Activities;
